import React, { Component } from 'react';
import CreateAdminMessages from './CreateAdminMessages.js'; //component for creating admin messages

export default class ManageAdminMessages extends Component {
	constructor(props){
		super(props);
		this.state = {newMessage:''};
	}

	render(){
		let messages = this.props.messages;
		let content;
		if(this.props.create){ //display CreateAdminMessages if user chooses create
			content = <CreateAdminMessages year={this.props.year} reset={this.props.reset} years={this.props.years} userInfo={this.props.userInfo} save={this.props.save} revertSave={this.props.revertSave}/>
		}else if(messages !== undefined && messages.length > 0){ //display all admin message information for current year selected

				content = messages.map((messages,i)=>{
					return (<li className="fl w-100 bb b--light-silver" key={i}>
										<div className="fl w-100">
											<div className="fl w-100">
												<p className="b fl w-20">Message:</p>
												<div className="fl w-80"><p className="ml3">{messages.message}</p></div>
											</div>
											<div className="fl w-100">
												<p className="fl w-20 b">End Date: </p>
												<div className="fl w-80">
													<p className="ml3">{messages.end_date}</p>
												</div>
											</div>
										</div>
									</li>);
				});

			}else{ //display messages if there are currently no admin messages for selected year
				content =  <li><p className="w-100 f3 tc">There is nothing to view at this time.</p></li>;
			}
		return(
			<div style={{maxWidth:'700px',margin:'auto'}}>
				<ul className="list">
					{content}
				</ul>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/container/ManageAdminMessages.js